import { ModalDefaultError } from "App/Component/ui";
import { instance1 } from "App/constants";
import { defaultToastError } from "App/utils/helpers";
import { useState, useEffect } from "react";

const getAllDokter = async (url) => {
  try {
    const api = await instance1.get(url);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

const useDokter = (url = "/doctor/listdoctor") => {
  const [rows, setRows] = useState([]);
  const [error, setError] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await getAllDokter(url);
      if (res) {
        setRows(res);
      } else {
        setError(true);
      }
    })();
  }, [url]);

  if (error) {
    return (
      <ModalDefaultError setShowModalDefaultError={() => setError(true)} />
    );
  }

  return rows;
};

export default useDokter;
